<template>
  <el-card>
    <div class="main-page">
      <div class="title mb20 flex item-center">我的模板</div>
      <div class="flex mb20 flex-wrap">
        <div class="temp custom" @click="toTemp(null)">
          <div class="custom-wrapper flex item-center flex-center">
            <div class="text-center">
              <span class="hmicon icon-weiyemian"></span>
              <div>自定义模板</div>
            </div>
          </div>
          <div class="temp-title">&nbsp;</div>
        </div>
        <div class="temp" v-for="(v, i) in templateList" :key="i">
          <div class="temp-wrapper">
            <div
              class="bg"
              :class="{ 'fixed-bottom': v.templateType !== 'model1' }"
            >
              <img :src="v.backgroundImg" />
            </div>
            <div class="temp-btn-wrapper">
              <div class="flex item-center wrapper">
                <div class="flex flex-wrap flex-start">
                  <el-tooltip
                    class="item"
                    content="编辑"
                    placement="top"
                    style="color: #0081E5"
                  >
                    <el-button
                      @click="edit(v)"
                      icon="hmicon icon-bianji"
                      circle
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    content="删除"
                    placement="top"
                    style="color: #0081E5"
                  >
                    <el-button
                      @click="remove(v.beltLayoutId)"
                      icon="hmicon icon-shanchu"
                      circle
                    ></el-button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="temp-title">{{ v.templateName }}</div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { setCookie } from "../../utils/utils";
export default {
  data() {
    return {
      templateList: []
    };
  },
  watch: {},
  mounted() {
    this.queyTempList();
  },
  methods: {
    async queyTempList() {
      const { result } = await this.$store.dispatch("queryBeltTempList", {
        pageNo: 1,
        pageSize: 9999
      });
      const { records } = result;
      this.templateList = records;
    },
    edit(row) {
      setCookie({
        key: "BELT_TEMP_ROW",
        type: "session",
        data: row
      });
      this.$router.push({
        name: "AddPromotionalBeltTemp",
        query: {
          beltLayoutId: row.beltLayoutId
        }
      });
    },
    remove(beltLayoutId) {
      this.$confirm(" 删除本条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("operationTemp", {
            beltLayoutId,
            operationType: "del"
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                type: "success",
                message: "操作成功！"
              });
            }
            this.queyTempList();
          });
      });
    },
    toTemp(layoutId) {
      let query = {
        pageModel: "customize"
      };
      if (layoutId) {
        Object.assign(query, {
          layoutId,
          mode: "edit"
        });
      }
      this.$router.push({
        name: "AddPromotionalBeltTemp",
        query
      });
    }
  }
};
</script>
<style>
.full-jcalendar__body .day-cell .day-number .solar {
  height: 18px;
}
.full-jcalendar .input-icon {
  top: 0 !important;
}
.full-jcalendar__body {
  height: 346px !important;
}
</style>
<style lang="scss" scoped>
.title {
  position: relative;
  font-size: 14px;
  font-weight: bold;
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 14px;
    background: rgba(229, 0, 101, 1);
    border-radius: 2px 0px 2px 0px;
    margin-right: 5px;
  }
}

.content {
  background: #ffeaf3;
  height: 106px;
}

.temp {
  position: relative;
  margin-right: 20px;
  cursor: pointer;
  margin-bottom: 20px;
  &:hover {
    .temp-btn-wrapper {
      display: block;
    }
  }
  &-wrapper {
    height: 160px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-title {
    background: #fff;
    font-size: 14px;
    font-weight: 500;
    width: 226px;
    text-align: center;
    padding: 11px 0;
  }
  &-btn-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 38px;
    height: 200px;
    padding-left: 35px;
    display: none;
    background: rgba(0, 0, 0, 0.8);
    .wrapper {
      height: 100%;
    }
    .el-button {
      margin: 0;
      margin-bottom: 20px;
      margin-right: 15px;
    }
  }
}
.temp {
  width: 180px;
  height: 200px;
  box-shadow: 0 1px 20px rgba(0, 0, 0, 0.1);
}

.temp-wrapper {
  .bg {
    height: 100%;
    &.fixed-bottom {
      display: flex;
      display: -webkit-flex;
      -webkit-align-items: flex-end;
      img {
        height: auto;
      }
    }
  }
}

.temp.custom {
  .custom-wrapper {
    height: 160px;
    background: #ffd4e7;
    text-align: center;
    color: #e50065;
    font-size: 14px;
    .hmicon {
      font-size: 42px;
    }
  }
}
</style>
